import React from 'react'
import Box from '@material-ui/core/Box'
import TipWell from 'components/tip-well'
import InfoOutlinedIcon from 'components/material-symbol/icons/Info'
import FormSubheader from '../form-subheader'
import Contact from '../../form-components/contact'
import Location from '../../form-components/location'
import { useCreateProfileFieldStyles } from '../field-styles'

const ContactLocationSection = () => {
  const fieldClasses = useCreateProfileFieldStyles()

  return (
    <Box className={fieldClasses.sectionStack}>
      <Box className={fieldClasses.fieldSection}>
        <FormSubheader
          title="Contact"
          description="How students can email or call you."
        />
        <Contact />
      </Box>
      <Box className={fieldClasses.fieldSection}>
        <FormSubheader title="Location" />
        <Box className={fieldClasses.tipFieldStack}>
          <TipWell
            icon={InfoOutlinedIcon}
            caption="Enter the city, state, and ZIP where you teach. This appears on your public PGA.com profile and helps golfers find you in search and on Google."
          />
          <Location />
        </Box>
      </Box>
    </Box>
  )
}

export default ContactLocationSection
